import maps from "./maps";
import time from "./time";
import icons from "./icons";
// @ts-ignore
import theme from "./theme";
// @ts-ignore
import toolbar from "./toolbar";
// @ts-ignore
import locales from "./locales";
// @ts-ignore
import analytics from "./analytics";
// @ts-ignore
import currencies from "./currencies";
// @ts-ignore
import navigation from "./navigation";

function getVersionNumber(): string {
  switch (process.env.VUE_APP_ENV) {
    case "production":
      return <string>process.env.VUE_APP_VERSION_PRODUCTION?.toString();
    case "production_mes1":
      return <string>process.env.VUE_APP_VERSION_PRODUCTION_MES1?.toString();
    default:
      return <string>process.env.VUE_APP_VERSION?.toString();
  }
}

export default {
  // product display information
  product: {
    name: "Finance - Sentec PMS",
    version: getVersionNumber()
  },

  // google maps
  maps,

  // time configs
  time,

  // icon libraries
  icons,

  // theme configs
  theme,

  // toolbar configs
  toolbar,

  // locales configs
  locales,

  // analytics configs
  analytics,

  // currencies configs
  currencies,

  // navigation configs
  navigation
};
